export const demoRestrictedOperations = [
    "ADD_SUBACCOUNT",
    "VALIDATE_API_KEY",
    "API_EXISTS",
    "SAVE_API_DETAILS",
    "SYNC_API_DETAIS",
    "CREATE_AGENT_DETAILS",
    "CLONE_AGENT_INFO",
    "DELETE_AGENT_INFO",
    "SAVE_AGENT_DETAILS",
    "SAVE_KNOWLEDGE_BASE",
    "SAVE",
    "EDIT",
    "ADD_AND_UPDATE_LISTS_TAGS",
    "FIELDADD",
    "FIELDUPDATE",
    "SAVE_OUTBOUND_DETAILS",
    "INVITE_USER",
    "UPDATE_INVITED_USER",
    "SAVE_PN_DETAILS",
    "SAVE_WIDGET",
    "UPDATE_WIDGET_STATUS",
    "GET_OAUTH_URL",
    "CONNECT_INTEGRATIONS",
    "DELETE_SUBACCOUNT",
    "UPDATE_SUBACC_SUBSCRIBE_STATUS",
    "UPDATE_ACCOUNT_NAME",
    "SAVE_API_DETAILS",
    "SYNC_API_DETAILS",
    "RESEND",
    "SAVE_AGENCY_DETAILS",
    "SAVE_DNS_RECORDS",
    "CHECK_EMAIL_CONNECTION",
    "SAVE_PLAN_PRICING",
    "SAVE_PERMISSIONS",
    "UPDATE_WEB_WIDGET",
    "UPDATE_IO_PHONE_DETAILS",
    "DELETE_AGENT_ACTIONS",
    "SAVE_ACTION_DETAILS",
    "SAVE_AGENT_SERVER_DATA"
];
